export enum RealTimeMediaStatus {
  LoadedMetadata,
  Playing,
  Paused,
  Waiting,
  Ended,
  Errored,
  /**
   * The user has chosen a different position in the audio
   * to skip to (i.e. clicked on a new location on the playback bar)
   */
  JumpedToTime,
  /**
   * The user clicked on the utterance's timestamp
   * to jump to its position in the audio. In this one case we don't
   * want to scroll the stt or use jump to time
   */
  JumpedOnClick,
  /**
   * The user has chosen to seek to the end of the recording,
   * needs to update the playhead unlike regular seeking which relies on user input
   */
  SeekToEnd,
}
